module.exports = __webpack_public_path__ + "img/nl-NL-add-to-apple-wallet.2cb2aaa.svg";